import React from "react";
import PropTypes from "prop-types";
import { ArrowUpRight, ChevronDown, Languages } from "lucide-react";
import Chat from "./Chat";
import GoogleTranslate from "./GoogleTranslate";

const UtilityBar = ({
  authenticationPath,
  registrationPath,
  user,
  isAgencyUser,
  chatAvailable,
  resourceListsPath,
  myReferralsPath,
  myAgencyDataPath,
  accountPath,
  signOutPath,
  organization,
}) => {
  // Extract Professionals link from navbar
  const professionalsLink = organization.navbar?.["Professionals"];
  const eLibraryLink = organization.navbar?.eLibrary;
  const externalLinkIcon = <ArrowUpRight aria-hidden="true" size={12} strokeWidth={2} style={{ marginLeft: "4px" }} />;

  return (
    <nav className="utility-bar">
      <div className="utility-bar-content">
        <div className="utility-bar-left">
          {eLibraryLink && (
            <a className="utility-link" href={eLibraryLink} target="_blank" rel="noopener noreferrer">
              eLibrary
              {externalLinkIcon}
            </a>
          )}
          {professionalsLink && (
            <a className="utility-link" href={professionalsLink} target="_blank" rel="noopener noreferrer">
              Professionals
              {externalLinkIcon}
            </a>
          )}
          
          <span className="google-translate">
            <Languages aria-hidden="true" color="white" size={16} strokeWidth={2} />
            <GoogleTranslate />
            <ChevronDown aria-hidden="true" className="google-translate-chevron" size={14} strokeWidth={2} style={{ marginLeft: 0 }} />
          </span>
          
          {organization.flags?.enableChat && (
            <div className="utility-chat">
              <Chat chatAvailable={chatAvailable} organization={organization} />
            </div>
          )}
        </div>

        <div className="utility-bar-right">
          {!user && (
            <>
              <a className="utility-link" href={authenticationPath}>
                Login
              </a>
              <a className="utility-link" href={registrationPath}>
                Sign Up
              </a>
            </>
          )}
          
          {user && (
            <div className="utility-account-dropdown dropdown account-nav">
              <a
                className="utility-link dropdown-toggle"
                id="utilityAccountMenu"
                aria-expanded="false"
                aria-haspopup="true"
                data-toggle="dropdown"
                type="button"
                href="#"
              >
                My 211 Account
                <span className="caret" style={{ marginLeft: "4px" }}></span>
              </a>
              <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="utilityAccountMenu">
                {isAgencyUser && (
                  <li>
                    <a href={myAgencyDataPath}>Agency</a>
                  </li>
                )}
                <li>
                  <a href={resourceListsPath}>Resource Lists</a>
                </li>
                {organization.userFeatures?.screeners && (
                  <li>
                    <a href="/my211/screeners">Screeners</a>
                  </li>
                )}
                {organization.userFeatures?.referrals && (
                  <li>
                    <a href={myReferralsPath}>Service Requests</a>
                  </li>
                )}
                <li>
                  <a href={accountPath}>Account Settings</a>
                </li>
                <li className="divider"></li>
                <li>
                  <a href={signOutPath} data-method="delete">
                    Log out
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

UtilityBar.propTypes = {
  authenticationPath: PropTypes.string,
  registrationPath: PropTypes.string,
  user: PropTypes.string,
  isAgencyUser: PropTypes.bool,
  chatAvailable: PropTypes.bool,
  resourceListsPath: PropTypes.string,
  myReferralsPath: PropTypes.string,
  myAgencyDataPath: PropTypes.string,
  accountPath: PropTypes.string,
  signOutPath: PropTypes.string,
  organization: PropTypes.object.isRequired,
};

export default UtilityBar;
